import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import playStore from "../assets/common/playStore.png";
import appStore from "../assets/common/appStore.png";
import moment from "moment";

const SessionFrequencyChart = ({ values, users }) => {
  // Filter users based on the selected timeframe
  const filteredUsers = users.filter((user) => {
    const lastLogin = moment(user.lastLogin);
    if (values === "Today") {
      return lastLogin.isSame(new Date(), "day");
    } else if (values === "Last 7 days") {
      return lastLogin.isSameOrAfter(moment().subtract(7, "days"));
    } else if (values === "Last 30 days") {
      return lastLogin.isSameOrAfter(moment().subtract(30, "days"));
    } else if (values === "Over All") {
      return true; // Include all users for "Overall"
    }
    return false;
  });

  // Initialize an array to count logins for each hour of the day
  const data = Array(24).fill(0);

  // Iterate over filteredUsers to calculate login frequency for each hour
  filteredUsers.forEach((user) => {
    const hour = moment(user.lastLogin).hour();
    data[hour] += 1;
  });

  // Calculate peak time and average session duration
  const peakIndex = data.indexOf(Math.max(...data));
  const peakTime = `${peakIndex % 12 === 0 ? 12 : peakIndex % 12} ${peakIndex < 12 ? "AM" : "PM"}`;
  const totalSessions = data.reduce((a, b) => a + b, 0);
  const avgSessionDuration =
    totalSessions > 0 ? Math.round(totalSessions / filteredUsers.length) : 0;

  const options = {
    chart: {
      type: "column",
      backgroundColor: "#fff",
      borderRadius: 8,
      height: 230,
      style: {
        fontFamily: "Arial, sans-serif",
      },
    },
    title: {
      text: "",
      align: "left",
      style: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#2f4fb5",
      },
    },
    xAxis: {
      categories: [
        "12 AM",
        "1 AM",
        "2 AM",
        "3 AM",
        "4 AM",
        "5 AM",
        "6 AM",
        "7 AM",
        "8 AM",
        "9 AM",
        "10 AM",
        "11 AM",
        "12 PM",
        "1 PM",
        "2 PM",
        "3 PM",
        "4 PM",
        "5 PM",
        "6 PM",
        "7 PM",
        "8 PM",
        "9 PM",
        "10 PM",
        "11 PM",
      ],
      tickInterval: 1,
      labels: {
        style: {
          color: "#6c757d",
          fontSize: 10,
        },
      },
    },
    yAxis: {
      title: {
        text: null,
      },
      labels: {
        style: {
          color: "#6c757d",
          fontSize: 10,
        },
      },
      gridLineColor: "#fff",
      max: Math.max(...data) + 1,
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      column: {
        zones: [
          {
            value: 5, // Less than 5 is considered Low
            color: "#C2D6FB",
          },
          {
            value: 10, // Between 5 and 10 is Medium
            color: "#C3C2FC",
          },
          {
            color: "#4454EE", // Greater than 10 is High
          },
        ],
        dataLabels: {
          enabled: false,
        },
      },
    },
    series: [
      {
        name: "Logins",
        data: data,
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return (
    <div style={{ position: "relative", maxWidth: "98%" }}>
      <div className="flex mb-2  mt-[-10px]">
        <div className="flex items-center">
          <img src={playStore} alt="App Store" className="h-2 w-2" />
          <p className="ml-2 text-[12px]">High</p>
        </div>
        <div className="flex items-center ml-2.5">
          <img src={appStore} alt="Play Store" className="h-2 w-2" />
          <p className="ml-2 text-[12px]">Medium</p>
        </div>
        <div className="flex items-center ml-2.5">
          <img src={playStore} alt="Play Store" className="h-2 w-2" />
          <p className="ml-2 text-[12px]">Low</p>
        </div>
      </div>

      <HighchartsReact highcharts={Highcharts} options={options} />
      <div className="border-b border-gray-200 mb-1" style={{ marginTop: -5 }}></div>

      <div
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          textAlign: "right",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          marginTop: -10,
        }}
      >
        <div className="flex flex-col justify-start mr-3 text-left ">
          <p style={{ fontSize: "14px", fontWeight: "bold", color: "#2f4fb5", marginLeft: 5 }}>
            {peakTime}
          </p>
          <p style={{ fontSize: "10px", color: "#6c757d", marginLeft: 5 }}>Peak Time</p>
        </div>
        <div className="flex flex-col justify-start text-left">
          <p style={{ fontSize: "14px", fontWeight: "bold", color: "#2f4fb5", marginLeft: 5 }}>
            {avgSessionDuration}
          </p>
          <p style={{ fontSize: "10px", color: "#6c757d", marginLeft: 5 }}>Avg. Session Duration</p>
        </div>
      </div>
    </div>
  );
};

export default SessionFrequencyChart;
